import { createReducer } from "reduxsauce";

export const INITIAL_STATE = {};

export const HANDLERS = {};

export default createReducer(INITIAL_STATE, HANDLERS);
